import styled from 'styled-components';

const StyledAsterisk = styled.span`
	font-family: ${props => props.theme.font};
	font-weight: ${props => props.theme.form.requiredAsterisk.fontWeight};
	color: ${props => props.theme.form.requiredAsterisk.color};
`;

export const RequiredAsterisk = ({ title } : {title?: string}) => <StyledAsterisk title={title}>*</StyledAsterisk>;
